<template>
<div>
  <div id="settings">
    Hi {{userProfile.name}}!
    Change your name here, idiot
    <form @submit.prevent>
      <input v-model.trim="name" type="text" :placeholder="userProfile.name">
      <button @click="updateProfile" class="button">Update</button>
    </form>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['userProfile'])
  },
  data: function () {
    return {
      name: '',
      title: '',
      showSuccess: true
    }
  },
  methods: {
    updateProfile () {
      this.$store.dispatch('updateProfile', {
        name: this.name !== '' ? this.name : this.userProfile.name
      })

      this.name = ''
      this.title = ''

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  margin: 1em;
}
#content {
  display: block;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  margin: 0px auto;
  padding: 20px;
  max-width: 1200px;
  background: white;
}

</style>
